const FETCH_RAISE_TYPES_REQUEST = "FETCH_RAISE_TYPES_REQUEST";
const FETCH_RAISE_TYPES_SUCCESS = "FETCH_RAISE_TYPES_SUCCESS";
const FETCH_RAISE_TYPES_FAILURE = "FETCH_RAISE_TYPES_FAILURE";

export default {
  FETCH_RAISE_TYPES_REQUEST,
  FETCH_RAISE_TYPES_SUCCESS,
  FETCH_RAISE_TYPES_FAILURE,
};
